/* smb-page.js: gallery, bundle picker, gifts, delivery date, add to cart, sticky bar */
(function () {
  var root = document.querySelector('[data-smb-hero]');
  if (!root) return;

  /* gallery */
  var slides = [].slice.call(root.querySelectorAll('[data-smb-slide]'));
  var thumbs = [].slice.call(root.querySelectorAll('[data-smb-thumb]'));
  var cur = 0;
  function show(i) {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    slides.forEach(function (s, n) { s.hidden = n !== cur; });
    thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === cur); t.setAttribute('aria-pressed', n === cur); });
    var t = thumbs[cur];
    if (t && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.offsetLeft - 8, behavior: 'smooth' }); }
  }
  thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
  [].forEach.call(root.querySelectorAll('[data-smb-arrow]'), function (b) {
    b.addEventListener('click', function () { show(cur + (b.getAttribute('data-smb-arrow') === 'next' ? 1 : -1)); });
  });

  /* bundle picker */
  var opts = [].slice.call(root.querySelectorAll('[data-smb-opt]'));
  var gifts = [].slice.call(root.querySelectorAll('[data-smb-gift]'));
  var ap = root.querySelector('[data-smb-ap]'), al = root.querySelector('[data-smb-al]');
  var hp = root.querySelector('[data-smb-hp]'), hl = root.querySelector('[data-smb-hl]');
  var sel = null;
  function pick(o) {
    sel = o;
    opts.forEach(function (x) { var on = x === o; x.classList.toggle('is-on', on); x.querySelector('input').checked = on; });
    var p = o.getAttribute('data-price'), l = o.getAttribute('data-compare');
    if (ap) ap.textContent = p; if (al) al.textContent = l;
    if (hp) hp.textContent = p; if (hl) hl.textContent = l;
    var idx = +o.getAttribute('data-index');
    gifts.forEach(function (g) {
      var from = +g.getAttribute('data-smb-gift');
      var open = from > 0 && idx >= from;
      g.classList.toggle('is-locked', !open);
      var st = g.querySelector('[data-smb-gift-state]');
      if (st) st.textContent = open ? st.getAttribute('data-open') : st.getAttribute('data-locked');
    });
  }
  opts.forEach(function (o) { o.querySelector('input').addEventListener('change', function () { pick(o); }); });
  var first = root.querySelector('[data-smb-opt].is-on') || opts[0];
  if (first) pick(first);

  /* delivery date */
  var dd = root.querySelector('[data-smb-days]');
  if (dd) {
    var d = new Date(); d.setDate(d.getDate() + (+dd.getAttribute('data-smb-days') || 5));
    var m = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var n = d.getDate(), sf = (n % 10 === 1 && n !== 11) ? 'st' : (n % 10 === 2 && n !== 12) ? 'nd' : (n % 10 === 3 && n !== 13) ? 'rd' : 'th';
    dd.textContent = m[d.getMonth()] + ' ' + n + sf;
  }

  /* add to cart */
  var atc = root.querySelector('[data-smb-atc]'), err = root.querySelector('[data-smb-err]');
  if (atc) atc.addEventListener('click', function () {
    if (!sel) return;
    var link = sel.getAttribute('data-link');
    if (link) { window.location.href = link; return; }
    var vid = sel.getAttribute('data-variant');
    if (!vid) { if (err) { err.hidden = false; err.textContent = 'This option is not connected to a product yet.'; } return; }
    var item = { id: +vid, quantity: +sel.getAttribute('data-qty') || 1 };
    var plan = sel.getAttribute('data-plan'); if (plan) item.selling_plan = +plan;
    var items = [item];
    var gift = sel.getAttribute('data-gift'); if (gift) items.push({ id: +gift, quantity: 1 });
    atc.disabled = true; if (err) err.hidden = true;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { window.location.href = base + (atc.getAttribute('data-after') || 'cart'); })
      .catch(function (e) { atc.disabled = false; if (err) { err.hidden = false; err.textContent = (e && (e.description || e.message)) || 'Something went wrong. Please try again.'; } });
  });

  /* sticky bar: shows once the main button has scrolled away */
  var bar = document.querySelector('[data-smb-bar]');
  if (bar && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      bar.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }).observe(atc);
  }
})();
